import React, { Fragment, useEffect,useState,useReducer } from "react";
import {connect} from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {Row,Col,Card,Table,Button,Modal,Dropdown} from "react-bootstrap";
import ToastAlert from "../components/Magpie/ToastAlert";
import {useNavigate} from 'react-router-dom';
import PagePagination from "../components/Magpie/PagePagination";
import useAuthIngest from "../../hooks/useAuthIngest"
import {getRoleAsync} from "../../store/actions/role.action";
import {Formik} from 'formik';
import * as Yup from "yup";
import Input from "../components/Magpie/Input";
import AutoCompleteField from "../components/Magpie/AutoCompleteField";
import '../../css/autocomplete-css.css'
import {getLedgerAsync} from "../../store/actions/ledger.action";
import SweetAlertButton from "../components/Magpie/SweetAlertButton";
import useAuthGetData from "../../hooks/useAuthGetData";
import swal from "sweetalert";
import TextArea from "../components/Magpie/TextArea";


Yup.addMethod(Yup.string, "checkDecimal", function (errorMessage) {
    return this.test(`check-decimal`, errorMessage, function (value) {
        const { path, createError } = this;
        let regexGlobal = /^(\d+(?:[\.]\d{1,2})?)$/;
        let testValue = typeof value === 'undefined' ? 0 : value
        return (
            (regexGlobal.test(testValue)) || createError({ path, message: errorMessage })
        );
    });
});

const userSchema = Yup.object().shape({
    customers: Yup.string()
        .required("Please provide a customer name")
        .max(250, "Provided name is too long"),
    credit:Yup.string()
        .checkDecimal("Please provide a valid amount"),
    debit:Yup.string()
        .checkDecimal("Please provide a valid amount")

});

const Ledger = ({getLedgerFunc,ledger,roleFunc,roles,login,mount,orgSession}) => {

    const [message,setMessage] = useState("");
    const [status, setStatus] = useState(false);
    const [isSuccess,setIsSuccess] = useState(false);
    const [fired,setFired] = useState(false);
    const [dayStatus, setDayStatus] = useState(false);
    const [finalBalance, setFinalBalance] = useState(0);
    const [dayValue, setDayValue] = useState(0);
    const [peginateData, setPeginateData] = useState({});
    const navigate = useNavigate();
    const [isDayReady, setIsDayReady] = useState(true);
    const [isDayReadyMessage, setIsDayReadyMessage] = useState('');
    const [isDayReadyData, setIsDayReadyData] = useState({});
    const [btnLoad, setBtnLoad] = useState(false);
    const [btnClose, setBtnClose] = useState(false);
    const [scrHeight, setScrHeight] = useState('0px');
    const [customerName, setCustomerName] = useState('');
    const [closeDate, setCloseDate] = useState(new Date());
    const [filteredSuggestions, setFilteredSuggestions] = useState([]);


    const  HandleDimension = () => {
        const { innerWidth: width, innerHeight: height } = window;
        let avilHeight = Math.ceil((height/2))+'px'
        setScrHeight(height)
    }

    useEffect(() => {
        if(mount.status){
            if(login.isLogin){
                roleFunc()
                HandleDimension()
            }
            else{
                navigate("/login");
            }
        }
    }, [login,mount]);

    useEffect(() => {
        if(ledger.status){
            peginate(1,1000)
        }
    }, [ledger]);

    useEffect(() => {
        if(orgSession.status){
            getLedgerFunc({company_id:orgSession.data.id})
            LedgerSummery()
            CheckLedgerStatus()
        }
    }, [orgSession]);

    const HandleDelete  = async (values) =>{
        setFired(false)
        const respond = await useAuthIngest('/ledger-delete',{ledger_id:values});
        setFired(true)
        setMessage(respond.message)
        setStatus(respond.status)
        if(respond.status){
            getLedgerFunc({company_id:orgSession.data.id})
            LedgerSummery()
        }
    }

    const peginate = (page, perPage) => {
        let data = [];
        if(ledger.status && ledger.data.length > 0){
            let st = (page - 1) * perPage
            let chunk = page * perPage
            data =  ledger.data.slice(st, chunk);
        }
        setPeginateData(data)
    }

    const InsertLedger = async (values) => {
        const respond = await useAuthIngest('/add-ledger',values);
        setFired(true)
        setBtnLoad(false)
        setMessage(respond.message)
        setStatus(respond.status)
        if(respond.status){
            setCustomerName("")
            getLedgerFunc({company_id:orgSession.data.id})
            LedgerSummery()
        }

    }

    const SubmitFunction = async (values) => {
        setFired(false)
        setBtnLoad(true)
        if(values.credit !== "" || values.debit !== "" ){
            if(typeof orgSession.data.id !== 'undefined' ){
                values.company_id = orgSession.data.id;
                values.customers = customerName === '' ? values.customers : customerName;
                InsertLedger(values)
            }else{
                setFired(true)
                setMessage("Please select company")
                setStatus(false)
                setBtnLoad(false)
            }
        }else{
            setFired(true)
            setMessage("Please provide transaction Amount")
            setStatus(false)
            setBtnLoad(false)
        }
    }

    const handleSuggestion = (value) => {
        setCustomerName(value)
    }

    const LedgerSummery = async () => {
        let respond =  await useAuthGetData('ledger-day-summery',{company_id:orgSession.data.id})
        if(respond[0].status){
            setDayValue(respond[0].data);
            setDayStatus(respond[1].status);
            setFinalBalance(respond[1].status ? respond[1].data.balance : 0);
        }
    }

    const DayClosing = async () => {
        setFired(false)
        setBtnClose(true)
        const respond = await useAuthIngest('/close-ledger',{company_id:orgSession.data.id, day:closeDate.toISOString().split('T')[0]});
        setFired(true)
        LedgerSummery()
        CheckLedgerStatus()
        setMessage(respond.message)
        setStatus(respond.status)
        setBtnClose(false)
    }

    const CheckLedgerStatus = async () => {
        let respond =  await useAuthGetData('check-ledger-status',{company_id:orgSession.data.id})
        setIsDayReady(respond.status);
        setIsDayReadyMessage(respond.message);
        setIsDayReadyData(typeof respond.data !== 'undefined' ? respond.data : {});
    }

    const yesterday = () => {
        let currentDate = new Date()
        let yesterday = new Date(currentDate)
        return yesterday.setDate(yesterday.getDate() - 1)
    }

    return (
        <Fragment>
            <Row>
                {
                    fired ? <ToastAlert message={message} status={status} /> : ""
                }
                <Col lg={12} style={{minHeight:scrHeight}}>
                    <Card>
                        <Card.Header>
                            <Card.Title>Ledger</Card.Title>
                            <Card.Title>{dayValue}</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <div className="mb-2"></div>
                            {
                                !isDayReady ?
                                    <Row>
                                        <Col sm={12} md={12} lg={12} className="text-center">

                                            <h4>Please close un successful transaction on below dates</h4>
                                            <p>{isDayReadyMessage}</p>
                                            {
                                                Object.keys(isDayReadyData).length > 0 ?
                                                    isDayReadyData.map((r,i) => (
                                                        <p key={i}>{r.ledger_date}</p>
                                                    ))
                                                    : ""
                                            }
                                            <Row>
                                                <Col sm={4} md={4}></Col>
                                                <Col sm={4} md={4}>
                                                    <DatePicker  dateFormat="yyyy-MM-dd" maxDate={yesterday()} className="form-control" selected={closeDate} onChange={(date) => setCloseDate(date)} />
                                                    <div className="row ">
                                                        <div className="col-sm-12 mt-5">
                                                            {
                                                                !btnClose ?
                                                                    <Button
                                                                        variant=""
                                                                        type="button"
                                                                        className="btn btn-danger w-100"
                                                                        onClick={() =>
                                                                            swal({
                                                                                title: "Are you sure?",
                                                                                text: "You will going to close the day transactions",
                                                                                icon: "warning",
                                                                                buttons: true,
                                                                                dangerMode: true,
                                                                            }).then((willDelete) => {
                                                                                if (willDelete) {
                                                                                    DayClosing()
                                                                                } else {
                                                                                    swal("Day transaction not closed",{
                                                                                        icon:"error"
                                                                                    });
                                                                                }
                                                                            })
                                                                        }
                                                                    >
                                                                        End Of Day
                                                                    </Button>
                                                                    :
                                                                    <h1 className="la la-circle-o-notch la-spin me-2 text-danger " style={{fontSize:'40px'}} ></h1>
                                                            }
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col sm={4} md={4}></Col>
                                            </Row>

                                        </Col>
                                    </Row>
                                    :
                                    <Row>
                                        {
                                            !dayStatus ?
                                                <Col sm={12} md={3} lg={3}>

                                                    <Formik
                                                        initialValues={{
                                                            customers: "",
                                                            credit: "",
                                                            debit: "",
                                                            comment: "",
                                                        }}
                                                        validationSchema={userSchema}
                                                        onSubmit={(values, { setSubmitting,resetForm }) => {
                                                            setTimeout(() => {
                                                                SubmitFunction(values)
                                                                setSubmitting(false);
                                                                resetForm({values:''})
                                                            }, 400);
                                                        }}

                                                    >
                                                        {({ values,errors,handleChange,handleBlur,handleSubmit,isSubmitting }) => (
                                                            <form className="dz-form dzForm style-1 contact-bx" noValidate onSubmit={handleSubmit}>
                                                                <div className="row ">
                                                                    <div className="col-md-12">
                                                                        <label>Company Name </label>
                                                                        <h4>{orgSession.data.name}</h4>
                                                                    </div>
                                                                    <div className="col-md-12">
                                                                        <AutoCompleteField
                                                                            name="customers"
                                                                            placeholder="Customers"
                                                                            id="customers"
                                                                            errors={errors.customers}
                                                                            value={values.customers}
                                                                            handleChange={handleChange}
                                                                            isRequired={false}
                                                                            formRequired={false}
                                                                            handleSuggestion={handleSuggestion}
                                                                            url="customers"
                                                                            filteredSuggestions={filteredSuggestions}
                                                                            setFilteredSuggestions={setFilteredSuggestions}
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-12">
                                                                        <Input
                                                                            name="debit"
                                                                            id="debit"
                                                                            placeholder="Debit"
                                                                            errors={errors.debit}
                                                                            value={values.debit}
                                                                            handleChange={handleChange}
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-12">
                                                                        <Input
                                                                            name="credit"
                                                                            id="credit"
                                                                            placeholder="Credit"
                                                                            errors={errors.credit}
                                                                            value={values.credit}
                                                                            handleChange={handleChange}
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-12">
                                                                        <TextArea
                                                                            name="comment"
                                                                            id="comment"
                                                                            placeholder="Comment"
                                                                            errors={errors.comment}
                                                                            value={values.comment}
                                                                            handleChange={handleChange}
                                                                        />
                                                                    </div>


                                                                </div>

                                                                <div className="row ">
                                                                    <div className="col-sm-12">
                                                                        {
                                                                            !btnLoad ?
                                                                                <Button
                                                                                    variant=""
                                                                                    type="submit"
                                                                                    className="btn btn-primary w-100"
                                                                                >
                                                                                    Save changes
                                                                                </Button>
                                                                                :
                                                                                <h1 className="la la-circle-o-notch la-spin me-2 text-primary " style={{fontSize:'40px'}} ></h1>
                                                                        }
                                                                    </div>
                                                                </div>

                                                                <div className="row ">
                                                                    <div className="col-sm-12 mt-5">
                                                                        {
                                                                            !btnClose ?
                                                                                <Button
                                                                                    variant=""
                                                                                    type="button"
                                                                                    className="btn btn-danger w-100"
                                                                                    onClick={() =>
                                                                                        swal({
                                                                                            title: "Are you sure?",
                                                                                            text: "You will going to close the day transactions",
                                                                                            icon: "warning",
                                                                                            buttons: true,
                                                                                            dangerMode: true,
                                                                                        }).then((willDelete) => {
                                                                                            if (willDelete) {
                                                                                                DayClosing(new Date().toISOString().split('T')[0])
                                                                                            } else {
                                                                                                swal("Day transaction not closed",{
                                                                                                    icon:"error"
                                                                                                });
                                                                                            }
                                                                                        })
                                                                                    }
                                                                                >
                                                                                    End Of Day
                                                                                </Button>
                                                                                :
                                                                                <h1 className="la la-circle-o-notch la-spin me-2 text-danger " style={{fontSize:'40px'}} ></h1>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </form>
                                                        )}
                                                    </Formik>

                                                </Col>
                                                :
                                                <Col sm={12} md={4} lg={4}>

                                                    <p>Ledger Closed for the Day</p>
                                                    <h5>Final Balance</h5>
                                                    <h3>{finalBalance}</h3>

                                                </Col>
                                        }

                                        <Col sm={12} md={9} lg={9} onClick={()=>setFilteredSuggestions([])}>
                                            {
                                                ledger.status ?
                                                    <Table responsive className="header-border">
                                                        <thead>
                                                        <tr>
                                                            <th>Ledger Date</th>
                                                            <th>Customer</th>
                                                            <th>Debit</th>
                                                            <th>Credit</th>
                                                            <th>Balance</th>
                                                            <th></th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            peginateData.length > 0 ?
                                                                peginateData.map((row,i) => (
                                                                    <Fragment key={i}>
                                                                        <tr>
                                                                            <td style={{borderStyle:'dashed'}}>{row.ledger_date}</td>
                                                                            <td style={{borderStyle:'dashed'}}>{row.customer_name}</td>
                                                                            <td style={{borderStyle:'dashed'}} align="right">{row.transaction_type === 'D' ? row.transaction_amount: 0}</td>
                                                                            <td style={{borderStyle:'dashed'}} align="right">{row.transaction_type === 'C' ? row.transaction_amount : 0}</td>
                                                                            <td style={{borderStyle:'dashed'}}>{row.balance}</td>
                                                                            <td style={{borderStyle:'dashed'}}>
                                                                                {
                                                                                    !dayStatus ?
                                                                                        <SweetAlertButton
                                                                                            isSuccess={isSuccess}
                                                                                            actionFunc={()=>HandleDelete(row.id)}
                                                                                            icon='fa fa-minus-square cursor-pointer'
                                                                                            bodyMsg='Delete'
                                                                                            cancelMsg="Fail, Your data is secure"
                                                                                            okMsg={message}
                                                                                        />
                                                                                        : ""
                                                                                }

                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td colSpan="6"> Comment : {row.comment}</td>
                                                                        </tr>
                                                                    </Fragment>
                                                                ))
                                                                :
                                                                <tr>
                                                                    <td>&nbsp;</td>
                                                                </tr>
                                                        }
                                                        </tbody>
                                                    </Table>
                                                    : ""
                                            }

                                            {
                                                ledger.status && ledger.data.length > 0 ?
                                                    <div className="pt-2 m-l5">
                                                        <PagePagination dataCount={ledger.data.length} perPage="1000" pegiFunction={peginate} />
                                                    </div> : ""
                                            }
                                        </Col>

                                    </Row>
                            }

                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Fragment>
    );

}

const initMapStateToProps = state => ({
    ledger: state.ledger,
    login: state.auth,
    roles: state.roles,
    operation: state.operation,
    mount: state.mount,
    orgSession: state.orgSession

})

const initMapDispatchToProps = dispatch => ({
    getLedgerFunc: (data) => dispatch(getLedgerAsync(data)),
    roleFunc: () => dispatch(getRoleAsync()),
})

export default connect(initMapStateToProps,initMapDispatchToProps) (Ledger)